module.exports = __webpack_public_path__ + "static/new-horizontal-color-f0a2f94f60949909442a615711c6a869.png";